export const environment = {
  production: false,
  canActivate: true,
  baseUrl:  'https://trendlyapi.sequantixapps.com',
  encryption: {
    enable: true,
  },
  timerIdle: 300,
};
